export const SEARCH_LIMIT = 10;
export const TYPE_SEARCH_LIMIT = 50;
